export function wait(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
export function waitReadyState() {
    return new Promise((resolve, reject) => {
        if (typeof document !== 'undefined' && document.readyState !== 'complete') {
            let old_onreadystatechange = document.onreadystatechange;
            document.onreadystatechange = function (event) {
                if (document.readyState === 'complete') {
                    resolve();
                    if (old_onreadystatechange) {
                        old_onreadystatechange.bind(document)(event);
                    }
                    document.onreadystatechange = old_onreadystatechange;
                    old_onreadystatechange = null;
                }
                else {
                    if (old_onreadystatechange) {
                        old_onreadystatechange.bind(document)(event);
                    }
                }
            };
        }
        else {
            resolve();
        }
    });
}
